import { MyReactions, PostReactionType, ReactionStats } from '__generated__/graphql/legacy/graphql';
import { Emoji } from 'emoji-mart';

import React from 'react';

import { Text } from '@thinkific/chalk/Text';
import { Tooltip } from '@thinkific/chalk/Tooltip';

import { useCommunityContext } from '../../../CommunityContext';
import { formatReactionCount, transformReactionStats } from '../../utils/reactionUtils';
import * as css from './ReactionSummaryDisplay.css';

interface ReactionSummaryDisplayProps {
  reactionStats?: ReactionStats;
  myReactions?: MyReactions;
  className?: string;
  onReactionClick: (reactionType: PostReactionType) => void;
}

const ReactionSummaryDisplay = ({
  reactionStats,
  myReactions,
  className,
  onReactionClick,
}: ReactionSummaryDisplayProps) => {
  const { currentUser } = useCommunityContext();

  // Pass current user's full name for optimistic display when user has reacted
  const currentUserFullName = currentUser ? currentUser.fullName : undefined;
  const reactionsToDisplay = transformReactionStats(
    reactionStats,
    myReactions,
    currentUserFullName
  );

  if (reactionsToDisplay.length === 0) {
    return null;
  }

  const handleReactionClick = (reactionType: PostReactionType) => {
    // Call the parent handler (parent manages optimistic updates)
    onReactionClick?.(reactionType);
  };

  return (
    <div className={`${css.reactionsSummaryContainerStyle} ${className || ''}`}>
      {reactionsToDisplay.map((reaction) => {
        return (
          <Tooltip direction="top" key={reaction.id} label={reaction.reactors || reaction.name}>
            <button
              className={`${css.reactionSummaryItemStyle} ${
                reaction.hasReacted
                  ? css.reactionSummaryItemActiveStyle
                  : css.reactionSummaryItemInactiveStyle
              }`}
              key={reaction.id}
              type="button"
              onClick={() => handleReactionClick(reaction.reactionType as PostReactionType)}
            >
              <Emoji emoji={reaction.id} size={20} native />
              <Text as="span" variant="label.xs">
                {formatReactionCount(reaction.count)}
              </Text>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default ReactionSummaryDisplay;
